<template>
  <span>
    <!-- <a
        class="subheading mx-3 fake-link"
        >
        About
        </a> -->
    <v-icon class="ml-2 small-help" @click.stop="dialog = true">
      mdi-help-circle-outline
    </v-icon>
    <v-row justify="center">
      <v-dialog v-model="dialog" max-width="400">
        <v-card>
          <v-card-title class="headline">TfL Journey Planner</v-card-title>
          <v-card-text>
            The website relies on the public TfL Journey Planner to check the
            route you might take.
          </v-card-text>
          <v-card-text>
            For the time being there's unfortunately no way to alter the route
            given, please let us know if this is a feature you'd like to see.
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="primary darken-1" text @click="dialog = false">
              Close
            </v-btn>

            <!-- <v-btn
                            color="green darken-1"
                            text
                            @click="dialog = false"
                        >
                            Agree
                        </v-btn> -->
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </span>
</template>
<script>
export default {
  name: "TfLHelpModal",
  data() {
    return {
      dialog: false
    };
  }
};
</script>
<style scoped>
.small-help {
  font-size: 1em !important;
}
</style>
